import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { HEADER_VIDEO_CONVERTER_TOKEN, HeaderVideoConverter } from './header-video.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        headerVideoFeature: {
          module: () => import('./header-video.module').then((m) => m.HeaderVideoModule),
          cmsComponents: ['header_video'],
        },
      }
    }),
    {
      provide: HEADER_VIDEO_CONVERTER_TOKEN,
      useExisting: HeaderVideoConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        header_video: HEADER_VIDEO_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class HeaderVideoFeatureModule {}
